import { Link as RouterLink } from "react-router-dom";
import { Link, TableCell, TableRow, Typography } from "@mui/material";
import { Flex } from "../Flex";
import { numberKFormat } from "~/lib/number-k-formatting";
import { SpaceSummaryAssetGroupButtons } from "./SpaceSummaryAssetGroupButtons";
import { ViewType } from "../view-switcher";
import { SpaceSummaryData, useSpaceSummary } from "./useSpaceSummary";
import { PriorityFindingsDeltaPercentage } from "~/pages/space/home-dashboard/PriorityFindingsCard/components/PriorityFindingsDeltaPercentage";

export type SpaceSummaryRowProps = {
  summaryData: SpaceSummaryData;
};

export function SpaceSummaryRow({ summaryData }: SpaceSummaryRowProps) {
  const spaceSummary = useSpaceSummary({ summaryData });
  const { name, assetGroupStats } = spaceSummary;
  const { dailyAssetsCounts, dailyPriorityFindingsCounts } = spaceSummary;
  const { overviewHref } = spaceSummary;

  return (
    <TableRow className="space-summary-row">
      <TableCell>
        <Link
          component={RouterLink}
          to={overviewHref}
          sx={{
            color: "text.primary",
            fontWeight: 700,
            ":hover": { textDecoration: "underline", color: "primary.light" },
          }}
        >
          {name}
        </Link>
      </TableCell>
      <TableCell>
        <SpaceSummaryAssetGroupButtons
          viewType={ViewType.List}
          assetGroupStats={assetGroupStats}
        />
      </TableCell>
      <TableCell align="right">
        <Flex gap={1} alignItems="center" justifyContent="flex-end">
          <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
            {numberKFormat.format(dailyAssetsCounts.newestCount)}
          </Typography>
          <Typography
            sx={{ fontWeight: 700, fontSize: 12, color: "text.secondary" }}
          >
            ({dailyAssetsCounts.countDelta})
          </Typography>
          <PriorityFindingsDeltaPercentage
            deltaCount={dailyAssetsCounts.countDelta}
            deltaPercentage={dailyAssetsCounts.countDeltaPercentage}
            color={"secondary"}
            small
            sx={{ minWidth: 64 }}
          />
        </Flex>
      </TableCell>
      <TableCell align="right">
        <Flex gap={1} alignItems="center" justifyContent="flex-end">
          <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
            {numberKFormat.format(dailyPriorityFindingsCounts.newestCount)}
          </Typography>
          <Typography
            sx={{ fontWeight: 700, fontSize: 12, color: "text.secondary" }}
          >
            ({dailyPriorityFindingsCounts.countDelta})
          </Typography>
          <PriorityFindingsDeltaPercentage
            deltaCount={dailyPriorityFindingsCounts.countDelta}
            deltaPercentage={dailyPriorityFindingsCounts.countDeltaPercentage}
            color={"primary"}
            small
            sx={{ minWidth: 64 }}
          />
        </Flex>
      </TableCell>
    </TableRow>
  );
}
